import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function PainterFlamingovlei() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('overview');

  const painter = {
    id: "painters-flamingovlei",
    name: "Painters Flamingo Vlei",
    location: "Flamingo Vlei, Cape Town",
    rating: 4.8,
    reviews: 142,
    specialties: ["Residential Estates", "Family Homes", "Modern Finishes", "Property Maintenance"],
    image: "https://public.readdy.ai/ai/img_res/61cfb954c6669e43a5defc6d837ed5a7.jpg",
    verified: true,
    yearsExperience: 14,
    website: "https://paintersflamingovlei.co.za",
    email: "info@paintersflamingovlei.co.za",
    description: "Professional painting services in Flamingo Vlei and surrounding West Coast areas. We specialize in residential estates and family homes with expertise in modern finishes and comprehensive property maintenance solutions.",
    services: [
      "Interior House Painting",
      "Exterior House Painting", 
      "Estate Property Painting",
      "Modern Design Finishes",
      "Roof Painting & Coatings",
      "Waterproofing Services",
      "Damp Proofing Solutions",
      "Color Consultation & Design"
    ],
    serviceAreas: ["Flamingo Vlei", "West Beach", "Sunset Beach", "Melkbosstrand", "Big Bay", "Bloubergstrand", "Parklands", "West Coast"],
    gallery: [
      "https://readdy.ai/api/search-image?query=Beautiful%20interior%20living%20room%20painted%20by%20professional%20painters%20in%20Flamingo%20Vlei%2C%20modern%20family%20home%20with%20fresh%20white%20walls%2C%20quality%20paint%20finish%2C%20lagoon%20view%2C%20bright%20natural%20lighting%2C%20clean%20professional%20painting%20work%2C%20contemporary%20design&width=400&height=300&seq=flamingovlei-gallery-1&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20house%20painting%20project%20in%20Flamingo%20Vlei%20Cape%20Town%2C%20residential%20estate%20home%20with%20fresh%20paint%2C%20professional%20painters%20working%2C%20quality%20exterior%20finish%2C%20modern%20architecture%2C%20well-maintained%20property&width=400&height=300&seq=flamingovlei-gallery-2&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Residential%20estate%20painting%20project%20in%20Flamingo%20Vlei%2C%20professional%20painters%20working%20on%20family%20home%20exterior%2C%20quality%20residential%20paint%20finish%2C%20contemporary%20architecture%2C%20organized%20work%20site&width=400&height=300&seq=flamingovlei-gallery-3&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Kitchen%20interior%20painting%20in%20Flamingo%20Vlei%20modern%20home%2C%20fresh%20painted%20walls%2C%20contemporary%20kitchen%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=flamingovlei-gallery-4&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Master%20bedroom%20interior%20painting%20in%20Flamingo%20Vlei%20estate%20home%2C%20fresh%20painted%20walls%2C%20modern%20bedroom%20design%2C%20quality%20paint%20finish%2C%20bright%20clean%20space%2C%20professional%20painting%20work&width=400&height=300&seq=flamingovlei-gallery-5&orientation=landscape",
      "https://readdy.ai/api/search-image?query=Exterior%20facade%20painting%20in%20Flamingo%20Vlei%20residential%20estate%2C%20professional%20painters%20working%20on%20modern%20home%2C%20quality%20exterior%20finish%2C%20contemporary%20architecture%2C%20pristine%20work%20environment&width=400&height=300&seq=flamingovlei-gallery-6&orientation=landscape"
    ],
    testimonials: [
      {
        name: "Andrew Stevens",
        rating: 5,
        comment: "Excellent work on our Flamingo Vlei home. The team was professional, efficient, and the quality of the finish is outstanding. They understood our vision and delivered exactly what we wanted."
      },
      {
        name: "Linda Botha", 
        rating: 5,
        comment: "Outstanding service from start to finish. They completed our estate home painting with great attention to detail and the modern finishes look amazing. Highly recommend for Flamingo Vlei properties."
      },
      {
        name: "Peter Johnson",
        rating: 5,
        comment: "Professional painters who truly understand modern home design. They were clean, punctual, and the quality exceeded our expectations. Our home looks fantastic."
      }
    ]
  };

  useEffect(() => {
    document.title = "Painters Flamingo Vlei | Professional Residential Painting Services Cape Town | Estate Home Specialists";
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Painters Flamingo Vlei offers professional painting services for residential estates and family homes in Flamingo Vlei, Cape Town. Specializing in modern finishes, property maintenance, and comprehensive painting solutions. Get a free quote today.');
    }
    
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Painters Flamingo Vlei, house painters West Coast, residential estate painting Cape Town, modern home painting, property maintenance painting');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative h-96 bg-gradient-to-r from-blue-600 to-blue-800">
        <div 
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url(https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20modern%20family%20home%20in%20Flamingo%20Vlei%20Cape%20Town%2C%20beautiful%20residential%20estate%20with%20lagoon%20and%20wetland%20views%2C%20painters%20in%20clean%20uniforms%20with%20premium%20equipment%2C%20contemporary%20architecture%20with%20clean%20lines%2C%20bright%20natural%20lighting%2C%20high%20quality%20residential%20painting%20project&width=1200&height=600&seq=flamingovlei-painters-hero&orientation=landscape)` }}
        >
          <div className="absolute inset-0 bg-black bg-opacity-50"></div>
        </div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-full flex items-center">
          <div className="text-white">
            <div className="flex items-center mb-4">
              <h1 className="text-4xl md:text-5xl font-bold mr-4">{painter.name}</h1>
              {painter.verified && (
                <div className="bg-green-500 text-white px-3 py-1 rounded-full text-sm font-semibold flex items-center">
                  <i className="ri-shield-check-line mr-1"></i>
                  Verified
                </div>
              )}
            </div>
            
            <p className="text-xl mb-4 flex items-center">
              <i className="ri-map-pin-line mr-2"></i>
              {painter.location}
            </p>
            
            <div className="flex items-center space-x-6 mb-6">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill ${i < Math.floor(painter.rating) ? 'text-yellow-400' : 'text-gray-400'}`}></i>
                ))}
                <span className="ml-2">{painter.rating} ({painter.reviews} reviews)</span>
              </div>
              <span>{painter.yearsExperience} years experience</span>
            </div>
            
            <div className="flex space-x-4">
              <button 
                onClick={() => navigate('/quote')}
                className="bg-lime-400 text-black px-6 py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
              >
                Get Free Quote
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Navigation Tabs */}
      <section className="bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <nav className="flex space-x-8">
            {[
              { id: 'overview', label: 'Overview' },
              { id: 'services', label: 'Services' },
              { id: 'gallery', label: 'Gallery' },
              { id: 'reviews', label: 'Reviews' },
              { id: 'contact', label: 'Contact' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`py-4 px-2 border-b-2 font-medium text-sm whitespace-nowrap cursor-pointer ${
                  activeTab === tab.id
                    ? 'border-lime-500 text-lime-600'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>
      </section>

      {/* Content Sections */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {activeTab === 'overview' && (
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              <div className="lg:col-span-2">
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Professional Painting Services in Flamingo Vlei</h2>
                <p className="text-gray-700 text-lg leading-relaxed mb-8">
                  {painter.description}
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Modern Residential Estate Painting Specialists</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Flamingo Vlei is a sought-after residential area on Cape Town's West Coast, known for its beautiful lagoon views, modern family homes, and strong community atmosphere. Our team has over 14 years of specialized experience working in this growing neighborhood, understanding the high standards expected by Flamingo Vlei homeowners and the unique requirements of contemporary residential properties. We've built our reputation on delivering exceptional painting services that enhance property value while providing long-lasting protection and modern aesthetic appeal.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  The homes in Flamingo Vlei represent the best of modern residential design, featuring clean lines, open-plan living spaces, and contemporary finishes. Our painting services are specifically tailored to complement these architectural styles, using modern color palettes and premium finishes that enhance the contemporary aesthetic while providing practical durability for family living. We understand that your home is your family's sanctuary and a significant investment, which is why we approach every project with the professionalism, attention to detail, and quality craftsmanship that Flamingo Vlei homeowners deserve.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Estate Home Services</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Flamingo Vlei's residential estates require painting contractors who understand the specific requirements of estate living, including adherence to architectural guidelines, coordination with homeowners associations, and the need for minimal disruption to neighbors and the peaceful community environment. Our team is experienced in working within these parameters, ensuring all work meets estate standards while completing projects efficiently and professionally. We maintain clear communication with estate management and homeowners throughout the project, providing regular updates and addressing any concerns promptly and professionally.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  We offer comprehensive painting solutions for both interior and exterior projects, from single room updates to complete home transformations. Our painters are skilled in working with the modern architectural styles common in Flamingo Vlei, including contemporary designs with large windows, open-plan layouts, and indoor-outdoor living spaces. We understand the importance of maintaining the aesthetic harmony of the neighborhood while allowing each home to express its unique character and the personality of its owners. Our work enhances property values and contributes to the overall appeal of the Flamingo Vlei community.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Premium Materials for Modern Homes</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Modern homes deserve modern painting solutions. We exclusively use premium paints and coatings from leading manufacturers, selected specifically for their superior coverage, durability, and contemporary finish quality. Our paint selection includes products with advanced features such as stain resistance, superior washability, and excellent fade resistance, ensuring your home maintains its beautiful appearance for years to come. For interior spaces, we prioritize low-VOC and environmentally friendly products that are safe for your family while providing excellent performance and contributing to healthy indoor air quality.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our team consists of highly skilled painters with extensive experience in modern residential projects. We invest in ongoing training to ensure our painters are familiar with the latest techniques, products, and industry best practices. This commitment to excellence means you can trust that your Flamingo Vlei home is in capable hands, and the finished result will meet the highest standards of quality and craftsmanship. We take pride in our work and stand behind every project with comprehensive warranties and ongoing support to ensure your complete satisfaction.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Modern Color Design and Consultation</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Choosing the right colors for your modern home requires understanding current design trends while ensuring selections will remain timeless and appealing. Our professional color consultation services provide expert guidance based on years of experience and a deep understanding of how colors work in contemporary spaces with abundant natural light. We help you select palettes that enhance your home's architectural features, create the desired atmosphere in each room, and reflect modern design principles while expressing your personal style and preferences.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-6">
                  Our color consultants work closely with you to understand your vision and lifestyle needs, then provide recommendations that bring that vision to life. We consider factors such as the orientation of rooms, natural light patterns throughout the day, existing furnishings and finishes, and current design trends while ensuring the selections will remain fresh and appealing for years to come. We can also coordinate with interior designers and architects if you're working with design professionals, ensuring seamless integration of painting work into your overall design plan and vision for your home.
                </p>
                
                <h3 className="text-2xl font-semibold text-gray-900 mb-4">Comprehensive Property Protection</h3>
                <p className="text-gray-700 leading-relaxed mb-6">
                  Beyond aesthetic enhancement, painting plays a crucial role in protecting your property from weather damage, moisture penetration, and general wear and tear. Our exterior painting services include comprehensive surface preparation, treatment of any existing damage, application of appropriate primers and sealers, and multiple coats of premium weather-resistant paint. We pay special attention to areas most vulnerable to weather exposure, including window and door frames, fascia boards, and any areas where water can collect or penetrate, ensuring complete protection for your home's exterior surfaces.
                </p>
                
                <p className="text-gray-700 leading-relaxed mb-8">
                  We also offer specialized services such as roof painting and coating, waterproofing, and damp proofing to provide complete protection for your Flamingo Vlei property. Our roof coatings not only enhance appearance but also provide additional insulation and weather protection, helping to reduce energy costs and extend roof life. Waterproofing and damp proofing services are particularly important in Cape Town's climate, preventing moisture-related damage that can compromise structural integrity and create unhealthy living conditions. Our comprehensive approach ensures your home is protected from all angles and will remain in excellent condition for years to come.
                </p>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Our Specialties</h3>
                    <div className="flex flex-wrap gap-2">
                      {painter.specialties.map((specialty, index) => (
                        <span key={index} className="bg-lime-100 text-lime-800 px-3 py-1 rounded-full text-sm font-medium">
                          {specialty}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <div className="bg-gray-50 p-6 rounded-lg">
                    <h3 className="text-xl font-semibold text-gray-900 mb-4">Service Areas</h3>
                    <div className="space-y-2">
                      {painter.serviceAreas.slice(0, 4).map((area, index) => (
                        <div key={index} className="flex items-center text-gray-700">
                          <i className="ri-map-pin-line mr-2 text-lime-500"></i>
                          {area}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <div className="bg-gray-50 p-6 rounded-lg sticky top-6">
                  <div className="mb-6">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Professional%20painting%20team%20working%20on%20modern%20family%20home%20in%20Flamingo%20Vlei%20Cape%20Town%2C%20residential%20estate%20with%20lagoon%20views%2C%20painters%20in%20clean%20uniforms%20with%20quality%20equipment%2C%20contemporary%20architecture%2C%20bright%20natural%20lighting&width=400&height=300&seq=flamingovlei-sidebar-image&orientation=landscape"
                      alt="Professional painters Flamingo Vlei house painting services Cape Town residential estates"
                      className="w-full h-48 object-cover object-top rounded-lg"
                    />
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4">Quick Contact</h3>
                  <div className="space-y-4">
                    <div className="flex items-center">
                      <i className="ri-mail-line mr-3 text-lime-500"></i>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                    <div className="flex items-center">
                      <i className="ri-global-line mr-3 text-lime-500"></i>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        Visit Website
                      </a>
                    </div>
                  </div>
                  
                  <button 
                    onClick={() => navigate('/quote')}
                    className="w-full mt-6 bg-lime-400 text-black py-3 rounded-lg font-semibold hover:bg-lime-500 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    Get Free Quote
                  </button>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'services' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Comprehensive Painting Services in Flamingo Vlei</h2>
              
              <div className="mb-12">
                <h3 className="text-2xl font-semibold text-gray-900 mb-6">Modern Residential Painting Solutions</h3>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Our painting services are specifically designed for the unique requirements of Flamingo Vlei's modern residential properties. From interior room updates to complete exterior transformations, we provide comprehensive solutions that combine premium materials with expert craftsmanship and contemporary design sensibility.
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
                {painter.services.map((service, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6 hover:shadow-lg transition-shadow">
                    <div className="flex items-center mb-4">
                      <i className="ri-brush-line text-2xl text-lime-500 mr-3"></i>
                      <h3 className="text-lg font-semibold text-gray-900">{service}</h3>
                    </div>
                    <p className="text-gray-600">Professional {service.toLowerCase()} services with premium materials and expert modern residential application techniques.</p>
                  </div>
                ))}
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Interior Painting Excellence</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Our interior painting services transform Flamingo Vlei homes into beautiful, modern living spaces. We use premium low-VOC paints that are safe for your family while providing excellent coverage and durability. Our color consultation services help you choose contemporary palettes that enhance your home's architectural features and create the desired atmosphere in each room.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We understand the importance of protecting your home and belongings during painting projects. Our team takes extensive precautions to protect floors, furniture, and fixtures, maintaining clean work areas throughout the project. We work efficiently to minimize disruption to your family's daily life while delivering exceptional results.
                  </p>
                </div>
                <div>
                  <h3 className="text-2xl font-semibold text-gray-900 mb-4">Exterior Protection and Beauty</h3>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    Exterior painting in Flamingo Vlei requires premium materials and expert application to withstand Cape Town's variable climate. We use weather-resistant paints and protective coatings that provide excellent durability while maintaining beautiful appearance. Our comprehensive exterior painting process includes thorough surface preparation, appropriate primer application, and multiple coats of premium paint for maximum protection.
                  </p>
                  <p className="text-gray-700 mb-6 leading-relaxed">
                    We also offer specialized services such as roof painting and coating, waterproofing, and damp proofing to provide complete protection for your property. Our comprehensive approach ensures your home is fully protected from environmental damage while maintaining its modern aesthetic appeal for years to come.
                  </p>
                </div>
              </div>
            </div>
          )}

          {activeTab === 'gallery' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Recent Painting Projects in Flamingo Vlei</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Explore our portfolio of recent painting projects throughout Flamingo Vlei and surrounding West Coast areas. Each project demonstrates our commitment to quality workmanship and our expertise in modern residential painting applications.
              </p>
              
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {painter.gallery.map((image, index) => (
                  <div key={index} className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow">
                    <img 
                      src={image} 
                      alt={`${painter.name} project ${index + 1}`}
                      className="w-full h-64 object-cover object-top"
                    />
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-900 mb-2">Flamingo Vlei Project {index + 1}</h3>
                      <p className="text-gray-600 text-sm">Professional residential painting with premium materials and expert application techniques.</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'reviews' && (
            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-8">Customer Reviews and Testimonials</h2>
              <p className="text-gray-700 mb-12 leading-relaxed">
                Read what our satisfied customers throughout Flamingo Vlei have to say about our painting services. Our commitment to excellence and customer satisfaction is reflected in these genuine reviews from homeowners in the area.
              </p>
              
              <div className="space-y-6">
                {painter.testimonials.map((testimonial, index) => (
                  <div key={index} className="bg-white border border-gray-200 rounded-lg p-6">
                    <div className="flex items-center mb-4">
                      <div className="flex items-center">
                        {[...Array(5)].map((_, i) => (
                          <i key={i} className={`ri-star-fill ${i < testimonial.rating ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                        ))}
                      </div>
                      <span className="ml-3 font-semibold text-gray-900">{testimonial.name}</span>
                    </div>
                    <p className="text-gray-700 leading-relaxed">{testimonial.comment}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {activeTab === 'contact' && (
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">Contact Painters Flamingo Vlei</h2>
                <p className="text-gray-700 mb-8 leading-relaxed">
                  Ready to transform your Flamingo Vlei property with professional painting services? Contact us today for a free consultation and quote. We're here to help you achieve beautiful, long-lasting results that enhance your home and lifestyle.
                </p>
                
                <div className="space-y-6">
                  <div className="flex items-center">
                    <i className="ri-mail-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Email</h3>
                      <a href={`mailto:${painter.email}`} className="text-gray-700 hover:text-lime-600">
                        {painter.email}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-center">
                    <i className="ri-global-line text-2xl text-lime-500 mr-4"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Website</h3>
                      <a href={painter.website} target="_blank" rel="noopener noreferrer" className="text-gray-700 hover:text-lime-600">
                        {painter.website}
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-2xl text-lime-500 mr-4 mt-1"></i>
                    <div>
                      <h3 className="font-semibold text-gray-900">Service Area</h3>
                      <p className="text-gray-700">{painter.location} and surrounding West Coast areas</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-2xl font-bold text-gray-900 mb-6">Get Your Free Quote Today</h3>
                <p className="text-gray-700 mb-6 leading-relaxed">
                  Request a free, no-obligation quote for your Flamingo Vlei painting project. Our experienced team will assess your property and provide detailed recommendations tailored to modern residential requirements.
                </p>
                <button 
                  onClick={() => navigate('/quote')}
                  className="w-full bg-lime-400 text-black py-4 rounded-lg font-semibold hover:bg-lime-500 transition-colors text-lg whitespace-nowrap cursor-pointer"
                >
                  Request Free Quote
                </button>
              </div>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
